export type KeyCustodyState = 'in_office' | 'awaiting_pickup' | 'with_broker' | 'key_issued' | 'transferred'

type HistoryEvent = { type: string }
type KeyBooking = {
    status: string | null
    dropOutDate: string | null
    receptionHistory?: HistoryEvent[]
}
type KeyViewing = { keyBooking: KeyBooking }

const hasEvent = (item: KeyViewing, type: string): boolean =>
    item.keyBooking.receptionHistory?.some((event) => event.type === type) === true

/**
 * KeyBooking.Status alone does not distinguish a normal collection from an
 * overdue key. Keep that decision derived so the schedule updates when the
 * return deadline passes without a background mutation.
 */
export const resolveKeyCustodyState = (item: KeyViewing, now = new Date()): KeyCustodyState => {
    if (hasEvent(item, 'key_transferred')) return 'transferred'
    if (hasEvent(item, 'key_returned')) return 'in_office'
    if (item.keyBooking.status === 'Waiting for agent') return 'awaiting_pickup'
    if (item.keyBooking.status !== 'In-process') return 'in_office'

    const returnAt = item.keyBooking.dropOutDate == null ? null : new Date(item.keyBooking.dropOutDate)
    if (returnAt != null && Number.isFinite(returnAt.getTime()) && returnAt.getTime() <= now.getTime()) return 'key_issued'
    return 'with_broker'
}
